import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ca82a41c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=ca82a41c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca82a41c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca82a41c')) {
      api.createRecord('ca82a41c', component.options)
    } else {
      api.reload('ca82a41c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=ca82a41c&scoped=true&", function () {
      api.rerender('ca82a41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/abnormal_eport/components/detail.vue"
export default component.exports